import { connect } from "react-redux";

import actions from "../actions";
import Contents from "../components/Contents";
import storageManager from "../lib/storageManager";

const mapStateToProps = (state) => {
  return {
    menu: state.app.menu,
    activeMenu: state.app.activeMenu,
    visiblePasswordEditor: state.app.visiblePasswordEditor,
    visibleLangSelector: state.app.visibleLangSelector,
    toastContents: state.app.toastContents,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    contentsReady: () => dispatch(actions.app.contentsReady()),
    showConstructionSelector: () => dispatch(actions.app.showConstructionSelector()),
    fetchConstructions: (callback) => dispatch(actions.construction.fetchItems(callback)),

    fetchProgressRate: () => dispatch(actions.construction.fetchProgressRate()),
    fetchPollingGlobalData: () => {
      dispatch(actions.notifications.fetchNotificationsSummary());
    },
    logout: (cid) => {
      storageManager.removeConstruction(cid);
      dispatch(actions.login.logout());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Contents);
